import type { FabProps } from '@mui/material'
import { Fab } from '@mui/material'
import { Edit } from '@tunasong/icons'
import type { MouseEvent } from 'react'

export interface MobileButtonProps extends Omit<FabProps, 'onChange'> {
  edit: boolean
  onChange: (edit: boolean) => void
}

export const MobileEditButton = (props: MobileButtonProps) => {
  const { onChange, edit, ...restProps } = props

  const handleEdit = (ev: MouseEvent) => {
    ev.preventDefault()
    onChange(!edit)
  }

  return (
    <Fab color={edit ? 'secondary' : 'primary'} aria-label="Enable edit mode" {...restProps} onClick={handleEdit}>
      <Edit />
    </Fab>
  )
}
